<div #wrapper [attr.data-url]="updatedUrl()" [ngClass]="cssClass()">
    <vn-iframe [class]="iframeClass()" [origin]="host()" [url]="updatedUrl()" [allowPaymentAttr]="true" />
</div>
